import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";
import { text } from "@quickpoint.me/shared";

const welcome: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherWelcomeIntro}
						<br />
						<br />
						{text.tourSteps.teacherWelcomeNoCoding}
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: " " });
		},
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherWelcomeAccessibility}
						<br />
						<br />
						{text.tourSteps.teacherWelcomeWcag}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherWelcomeScreenReaders}
					</span>
				)}
			/>
		),
		position: "center",
	},
];

export default welcome;
